<template>
    <div>
        <!-- Begin:PageContent:Main -->
        <section id="content" class="image-bg3">
            <div class="container">
                <div class="row">
                    <div class="alert alert-help">
                        {{ alertmessage[getCurrentLocale] }}
                        <span class="close"></span>
                    </div>

                    <div class="alert alert-info">
                        {{ alertmessage2[getCurrentLocale] }}
                        <span class="close"></span>
                    </div>



                    <!-- Begin:Content-FlightSearchTabs-Booking -->
                    <div id="main" class="col-sm-8 col-md-9">
                        <sdr-shared-flightsearch-tabs modulo="services"></sdr-shared-flightsearch-tabs>
                    </div>
                    <!-- Begin:Content-FlightSearchTabs-Booking -->

                    <!-- Begin:Content-SideBar-Booking -->
                    <div class="sidebar col-sm-4 col-md-3">
                        <sdr-covid19-box></sdr-covid19-box>
                        <sdr-contact-box></sdr-contact-box>
                    </div>
                    <!-- End:Content-SideBar-Booking -->
                </div>
            </div>
        </section>
        <!-- End:PageContent:Main -->

        <!-- Begin:Content:FlightSearchResults -->
        <sdr-shared-flightsearchresults modulo="services"></sdr-shared-flightsearchresults>
        <!-- End:Content:FlightSearchResults -->

        <!-- Begin:Content:BookingnoOverview -->
        <sdr-services-bookingnooverview modulo="services"></sdr-services-bookingnooverview>
        <!-- End:Content:BookingnoOverview -->

        <!-- Begin:PromoBox -->
        <sdr-promobox></sdr-promobox>
        <!-- End:PromoBox -->
    </div>
</template>

<script>
    import FlightSearchTabs from '../shared/flightsearch/FlightSearchTabs.vue'; // Entire Tabs Construct (shared)
    import FlightSearchResults from '../shared/flightsearch/FlightSearchResults.vue'; // Content (shared)
    import BookingnoOverview from '../services/pagecontent/BookingnoOverview.vue'; // Services only

    import ContactBox from '../shared/sidebar/ContactBox.vue'; // Sidebar (right)
    import PromoBox from '../booking/pagecontent/PromoBox.vue';
    import Covid19Box from '../shared/sidebar/Covid19Box.vue'; // Sidebar (right)

    import { mapGetters } from 'vuex';


    export default {

        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-shared-flightsearch-tabs': FlightSearchTabs,
            'sdr-shared-flightsearchresults': FlightSearchResults,
            'sdr-services-bookingnooverview': BookingnoOverview,

            'sdr-contact-box': ContactBox,
            'sdr-covid19-box': Covid19Box,
            'sdr-promobox': PromoBox,

        }, // eof components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                alertmessage: {
                    en: 'Info: Dear passenger, here you can only reserve seats and book services after you already have a confirmed flight booking.',
                    de: 'Info: Sehr geehrter Fluggast, hier können Sie ausschließlich Sitzplätze reservieren und Services buchen, nachdem Sie bereits im Besitz einer bestätigten Flugbuchung sind.',
                },
                alertmessage2: {
                    en: 'Online check-in: Online check-in is not available. Please check in as usual at the counter.',
                    de: 'Online Check-in: Ein Online Check-in steht nicht zur Verfügung. Bitte checken Sie wie gewohnt am Schalter ein.',
                },
                alertmessage3: {
                    en: 'Due to technical problems, it is currently not possible to pay with a credit card.',
                    de: 'Aktuell ist aufgrund technischer Probleme keine Zahlung mit  Kreditkarte möglich.',
                },
                // getCurrentLocale: 'de',
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters(['getCurrentLocale']),

        }, // eof computed{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .alert.alert-help {
        background: #dcecf6;
        color: #406f8c;
        margin-left: 15px;
        margin-right: 15px;
    }

    .alert.alert-info {
        background: #dcecf6;
        color: #406f8c;
        margin-left: 15px;
        margin-right: 15px;
    }

    .alert.alert-warning {
        background: red;
        color: #fff;
        margin-left: 15px;
        margin-right: 15px;
        font-size: 14px;
        font-weight: 400;
    }
    .alert .close,
    .info-box .close {
        color: #406f8c;
    }
</style>


// WEBPACK FOOTER //
// src/components/services/Home.vue